import React from "react";
import PropTypes from "prop-types";
import { TrackBar } from "./styles";

export const Track = ({ source, target, getTrackProps, disabled = false }) => {
  return (
    <TrackBar
      $disabled={disabled}
      $leftPercent={source.percent - 12}
      $widthPercent={target.percent - source.percent + 24}
      {...getTrackProps()}
    />
  );
}

Track.propTypes = {
  source: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired
  }).isRequired,
  target: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    percent: PropTypes.number.isRequired
  }).isRequired,
  getTrackProps: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
